import { ViewComponent } from './view.component';

export default angular
  .module('sfMobile.components.view', [])
  .component('sfView', ViewComponent).name;
